var BASWebServices;
(function (BASWebServices) {
    var WebServiceCMDI = (function () {
        function WebServiceCMDI() {
        }
        WebServiceCMDI.createClassFromJSON = function (cmdi) {
            var retVal = cmdi.Header.MdCreator + "<br/>"
                + cmdi.Header.MdCreationDate + "<br/>"
                + cmdi.Resources.ResourceProxyList.ResourceProxy.ResourceRef + "<br/>" + "<br/>"
                + "--------------------------------------<br/>";
            var allOperations = cmdi.Components.BASWebService.Service.Operations.Operation;
            for (var i = 0; i < allOperations.length; i++) {
                retVal += allOperations[i].Name + ": <br/><br/>";
                if (allOperations[i].Input != null) {
                    var allParameters = allOperations[i].Input.Parameter;
                    for (var j = 0; j < allParameters.length; j++) {
                        retVal += "    " + allParameters[j].Name + "<br/>";
                    }
                }
                retVal += "--------------------------------------<br/>";
            }
            return retVal;
        };
        WebServiceCMDI.xmlToJSON = function (xml, retVal) {
            if (retVal == "") {
                retVal += xml.localName + " = { ";
                retVal += this.xmlToJSON(xml.childNodes[0], retVal);
                retVal += "}";
            }
            else if (xml.nodeName == "#text") {
                if (xml.nextSibling != null)
                    retVal += this.xmlToJSON(xml.nextSibling, retVal);
            }
            else if (xml.childElementCount > 0) {
                for (var i = 0; i < xml.childNodes.length; i++) {
                    retVal += "{";
                    retVal += xml.localName + ": ";
                    retVal += this.xmlToJSON(xml.childNodes[i], retVal);
                    retVal += "}";
                }
            }
            else {
                if (xml.firstChild.nodeValue != null) {
                    retVal += xml.localName + ": ";
                    retVal += xml.firstChild.nodeValue;
                    retVal += ",";
                }
                else {
                    retVal += xml.localName + ": ''";
                }
            }
            return retVal;
        };
        WebServiceCMDI.getOperation = function (operationsAvailable, name) {
            var operationsArray = operationsAvailable.Operation;
            for (var i = 0; i < operationsArray.length; i++) {
                var operation = operationsArray[i];
                if (operation.Name == name)
                    return operation;
            }
            return null;
        };
        return WebServiceCMDI;
    }());
    BASWebServices.WebServiceCMDI = WebServiceCMDI;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=Webservice.cmdi.js.map